import * as React from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import logo from "../images/logo-condensed-3.png"
import small_logo from "../images/icon-reverse-2.png"

// markup
const Nav = () => {
  const [menuOpen, setMenuOpen] = React.useState(false)

  return (
    <nav id="!" className="py-3 navbar navbar-expand-lg navbar-light bg-white">
      <Helmet>
        <title>GalaSoftware Srls</title>
        <link rel="canonical" href="https://galasoftware.it" />
      </Helmet>
      <div className="container">
        {/* brand / logo */}
        <Link className="navbar-brand" to="/" id="navbarLanding" role="button">
          <img src={logo} height={40} alt="Galasoftware" />
        </Link>
        <button className="navbar-toggler" type="button" onClick={() => setMenuOpen(true)} aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <div className={`collapse navbar-collapse ${menuOpen && 'show'}`} id="navbarMainContent">
          {/* mobile close */}
          <div className="d-flex d-lg-none pb-3 justify-content-between align-items-center">
            <img src={small_logo} height={40} alt="Galasoftware" />
            <button className="navbar-toggler" type="button" onClick={() => setMenuOpen(false)} aria-label="Toggle navigation">
              <svg height="28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <line x1={18} y1={6} x2={6} y2={18} /><line x1={6} y1={6} x2={18} y2={18} />
              </svg>
            </button>
          </div>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item dropdown dropdown-hover">
              <Link className="nav-link px-3 dropdown-toggle" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item dropdown dropdown-hover">
              <Link className="nav-link px-3 dropdown-toggle" to="/gs-access">
                GS-Access
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Nav
